import { render, staticRenderFns } from "./calendarMain.vue?vue&type=template&id=5754a334&scoped=true&"
import script from "./calendarMain.vue?vue&type=script&lang=js&"
export * from "./calendarMain.vue?vue&type=script&lang=js&"
import style0 from "./calendarMain.vue?vue&type=style&index=0&id=5754a334&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5754a334",
  null
  
)

export default component.exports